"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronDown = void 0;
/* eslint-disable import/prefer-default-export */
var react_1 = __importDefault(require("react"));
var ChevronDown = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24' : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.55806 10.5581C7.80214 10.314 8.19786 10.314 8.44194 10.5581L14 16.1161L19.5581 10.5581C19.8021 10.314 20.1979 10.314 20.4419 10.5581C20.686 10.8021 20.686 11.1979 20.4419 11.4419L14.4419 17.4419C14.1979 17.686 13.8021 17.686 13.5581 17.4419L7.55806 11.4419C7.31398 11.1979 7.31398 10.8021 7.55806 10.5581Z", fill: color })));
};
exports.ChevronDown = ChevronDown;
